import { useEffect, useCallback } from "react";

import { useLazyGetPcmNumberQuery } from "api/memberPortal/pcm/pcm.api";

import { type BreadcrumbProps } from "../MemberBreadcrumbs.types";
import {
  isPcmIdLink,
  getPcmNumber,
  displayName,
} from "../utils/Breadcrumb.functions";

const BreadcrumbName = ({ currentName }: BreadcrumbProps) => {
  const [triggerGetPcmNumber] = useLazyGetPcmNumberQuery();

  const setDisplay = useCallback(() => {
    getPcmNumber(currentName, triggerGetPcmNumber);
  }, [triggerGetPcmNumber, currentName]);

  useEffect(() => {
    if (isPcmIdLink(currentName)) {
      setDisplay();
    }
  }, [currentName, setDisplay]);

  return <>{displayName(currentName)}</>;
};

export default BreadcrumbName;
